import { createRoot, Root } from 'react-dom/client'

export default class BaseElement extends HTMLElement {
  protected get observedAttributes () {
    return []
  }

  protected rootElement: Root | null = null

  connectedCallback () {
    if (!this.rootElement) {
      this.rootElement = createRoot(this)
    }

    this.renderElement()
  }

  attributeChangedCallback () {
    if (this.rootElement) {
      this.renderElement()
    }
  }

  disconnectedCallback () {
    this.rootElement?.unmount()
    this.rootElement = null
  }

  protected renderElement () {}
}
